import { ICommand } from '../../../core/commands/ICommand';
import { CreateShapeCommand } from '../../../core/commands/CreateShapeCommand';
import { createTableFromSchema } from '../../diagram/shapes/table/createTableFromSchema';

export type SwimLaneDirection = 'horizontal' | 'vertical';

export interface CreateSwimLaneParams {
  x: number;
  y: number;
  direction?: SwimLaneDirection;
}

// Drops a 3-lane swimlane pool (a `table` shape with the swimlane schema)
// at the given position. Direction defaults to horizontal — lanes stacked
// top-to-bottom with their labels on the left rail — which matches the
// reading order of left-to-right flowcharts.
export class CreateSwimLaneCommand implements ICommand {
  id: string;
  name = 'Create Swim Lane';
  description?: string;
  timestamp: number;

  private params: CreateSwimLaneParams;
  private inner?: CreateShapeCommand;

  constructor(params: CreateSwimLaneParams) {
    this.id = `create-swim-lane-${Date.now()}`;
    this.timestamp = Date.now();
    this.params = params;
    this.description = 'Create a swim lane pool';
  }

  execute(): void {
    const direction: SwimLaneDirection = this.params.direction ?? 'horizontal';
    const schemaId = direction === 'vertical' ? 'swimlane-vertical' : 'swimlane-horizontal';
    this.inner = createTableFromSchema(schemaId, { x: this.params.x, y: this.params.y });
    this.inner.execute();
  }

  undo(): void {
    this.inner?.undo();
  }

  redo(): void {
    this.inner?.redo();
  }

  getCreatedId(): string | undefined {
    return this.inner?.getCreatedId?.();
  }
}
